import { styled } from '@components-shared/src/stitches';

export const Divider = styled('div', {
  backgroundColor: '$base200',
  height: 1,
  width: '100%',
  marginBottom: 16,

  variants: {
    orientation: {
      horizontal: {
        height: 1,
        width: '100%',
      },
      vertical: {
        width: 1,
        height: '100%',
      },
    },
  },
  defaultVariants: {
    orientation: 'horizontal',
  },
});
